var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',{attrs:{"disabled":_vm.record.options.disabled,"read-only":_vm.record.options.readonly,"placeholder":_vm.record.options.placeholder},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }